import { type MonitoringHoursType } from '../models/index.js';

export enum UpdateType {
  EVENT = 'event',
  RULE = 'rule',
}

export type MonitoringHoursRuleForm = {
  id?: string;
  eventId?: string;
  ruleStartDate?: string;
  start: Date;
  end: Date;
  freq?: number;
  interval?: number;
  until?: Date;
  byDay?: number[];
  repeats: boolean;
  type: MonitoringHoursType;
  checkInDuration?: number;
  checkInInterval?: number;
  updateType?: UpdateType;
};
